// Shared client-side date sorter for payment / dated child-record lists.
//
// sortByDate(list, field, direction)
//   - list:      array of records (defaults to [])
//   - field:     name of the date field on each record (defaults to 'date')
//   - direction: 'desc' = newest first (default), 'asc' = oldest first
//
// Returns a NEW array (does not mutate the input). Records with a missing,
// empty, or unparseable date are always sorted last, regardless of direction.
// The sort is stable, so records sharing the same date keep their original
// relative order.
export const sortByDate = (list = [], field = 'date', direction = 'desc') => {
  if (!Array.isArray(list)) return [];

  const toTime = (record) => {
    const raw = record ? record[field] : null;
    if (raw === null || raw === undefined || raw === '') return null;
    const t = new Date(raw).getTime();
    return Number.isNaN(t) ? null : t;
  };

  const dir = direction === 'asc' ? 1 : -1;

  // Decorate with original index to guarantee a stable sort across engines.
  return list
    .map((record, index) => ({ record, index, time: toTime(record) }))
    .sort((a, b) => {
      // Null/invalid dates always sink to the bottom.
      if (a.time === null && b.time === null) return a.index - b.index;
      if (a.time === null) return 1;
      if (b.time === null) return -1;
      if (a.time !== b.time) return (a.time - b.time) * dir;
      return a.index - b.index;
    })
    .map((entry) => entry.record);
};

export default sortByDate;
